/* eslint-disable */
import { Modal, Table, Dropdown, message, Tag } from "antd";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
  useRef,
} from "react";

import { Typography } from "antd";
const { Text, Link } = Typography;
import http from "@/utils/http";
import api from "@/utils/api";
import moment from "moment";
import {
  MenuOutlined,
  SolutionOutlined,
  EditOutlined,
  ExclamationCircleFilled,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import commonFn from "@/utils/commonFn";
import AddModal from "./AddModal";
import UpdateModal from "./UpdateModal";
const MainTable = forwardRef((props, ref) => {
  const [error, setError] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 13,
  });
  const [tableLoading, setTableLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const initialTableHead = {
    businessType: null,
    remark: null,
    status: null,
    createByName: null,
    updateByName: null,
    orderField: null,
    orderType: null,
  };
  const [tableHead, setTableHead] = useState(initialTableHead);
  const tableHeadRef = useRef(tableHead);
  const paginationRef = useRef(pagination);
  const navigate = useNavigate();
 
  const addModalRef = useRef();
  const roleModalRef = useRef();
  const updateModalRef = useRef();
  const items = [
    {
      key: "delete",
      icon: <EditOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
      label: <div>Delete Type</div>,
    },
    {
      key: "update",
      icon: <SolutionOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
      label: <div>View/Edit Type</div>,
    },
  ];
  // 暴露子组件方法
  useImperativeHandle(ref, () => ({
    getValue: () => columns,
    toggleColumnVisibility: (checkedValues) => {
      setColumns((prevColumns) => {
        return prevColumns.map(
          (col) =>
            checkedValues.includes(col.key)
              ? { ...col, hidden: false } // 如果列的 key 在 checkedValues 中，显示该列
              : { ...col, hidden: true } // 否则隐藏该列
        );
      });
    },

    newListFun: () => {
      //刷新列表
      setTableHead(initialTableHead);
      getTableListFn(1, 25, initialTableHead);
    },
    showModalAdd: () => {
      addModalRef.current?.setModelAdd();
    },
  }));


  // 定义列，包括输入框
  const tableFilterFn = (event, key, type = "Input") => {
    commonFn.tableFilterFn({ event, key, type, setTableHead, getTableListFn });
  };
  const initColumns = [
    {
      title: "Action",
      key: "action",
      dataIndex: "propId",
      hidden: false,
      align: "center",
      width: 60,
      render: (text, record, index) => (
        <Dropdown menu={menuProps(record)} trigger={["click"]}>
          <MenuOutlined className="col-blue" />
        </Dropdown>
      ),
    },
    {
      title: "Business Type",
      dataIndex: "businessType",
      key: "businessType",
      titleType: "Input",
      width: 200,
      align: "center",
      onChange: (e) => tableFilterFn(e, "businessType"),
      render: (text) => text,
    },
    {
      title: "Remark",
      dataIndex: "remark",
      key: "remark",
      titleType: "Input",
      width: 200,
      align: "center",
      onChange: (e) => tableFilterFn(e, "remark"),
      render: (text) => text,
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 110,
      align: "center",
      titleType: "Select",
      selectOptions: [
        { label: "All", value: "" },
        { label: "Active", value: "1" },
        { label: "Inactive", value: "2" },
      ],
      onChange: (value) => tableFilterFn(value, "status", "Select"),
      render: (_, record) => {
        const value = Number(record.status);
        if (!value) return "-";

        const handleClick = () => {
          const newValue = value === 1 ? 2 : 1;
          const statusText = newValue === 1 ? "Active" : "Inactive";
          const currentPage = paginationRef.current.current;
          const currentPageSize = paginationRef.current.pageSize;

          Modal.confirm({
            title: "Confirm Status Change",
            content: (
              <span>
                Are you sure you want to change the status to
                <span style={{ color: "#1890ff", fontWeight: 500 }}>
                  {" "}
                  {statusText}
                </span>
                ?
              </span>
            ),
            okText: "Confirm",
            cancelText: "Cancel",
            onOk: async () => {
              try {
                const res = await updateActiveStatus(record.id, newValue);
                if (res?.code === "1") {
                  message.success(res?.msg || "Status updated successfully");
                  getTableListFn(
                    currentPage,
                    currentPageSize,
                    tableHeadRef.current
                  );
                } else {
                  message.error(res?.msg || "Operation failed");
                }
              } catch (e) {
                const backendMsg =
                  e?.response?.data?.msg ||
                  e?.msg ||
                  e?.message ||
                  "Network error";
                message.error(backendMsg);
              }
            },
            style: { top: "40%" },
          });
        };

        return value === 1 ? (
          <Tag
            color="green"
            style={{ cursor: "pointer" }}
            onClick={handleClick}
          >
            Active
          </Tag>
        ) : (
          <Tag color="red" style={{ cursor: "pointer" }} onClick={handleClick}>
            Inactive
          </Tag>
        );
      },
    },

    {
      title: "Create By Name",
      dataIndex: "createByName",
      key: "createByName",
      titleType: "Input",
      width: 200,
      align: "center",
      onChange: (e) => tableFilterFn(e, "createByName"),
      render: (text) => text,
    },
    {
      title: "Update By Name",
      dataIndex: "updateByName",
      key: "updateByName",
      titleType: "Input",
      width: 200,
      align: "center",
      onChange: (e) => tableFilterFn(e, "updateByName"),
      render: (text) => text,
    },
      {
      title: "Create Time",
      dataIndex: "createTime",
      key: "createTime",
      titleType: "Input",
      width: 200,
      align: "center",
      onChange: (e) => tableFilterFn(e, "createTime"),
      render: (text) => {
        if (!text) return "-";
        return moment(parseInt(text)).format("YYYY-MM-DD HH:mm:ss");
      },
    },
    {
      title: "Update Time",
      dataIndex: "updateTime",
      key: "updateTime",
      titleType: "Input",
      width: 200,
      align: "center",
      onChange: (e) => tableFilterFn(e, "updateTime"),
      render: (text) => {
        if (!text) return "-";
        return moment(parseInt(text)).format("YYYY-MM-DD HH:mm:ss");
      },
    },
  ];
  const [columns, setColumns] = useState(commonFn.handleColunmFn(initColumns));
  //初始化数据
  const layout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 16,
    },
  };

  const menuProps = (record) => ({
    items,
    onClick: (e) => handleMenuClick(e, record),
  });

  //Action
  const handleMenuClick = async (e, record) => {
    if (e.key === "delete") {
      showDeleteConfirm(record);
    }

    if (e.key === "update") {
      updateModalRef.current?.showModal(record);
    }
    if (e.key === "on&off") {
      console.log(record);
      roleModalRef.current?.showModal(record);
    }
  };
  // 显示删除确认对话框
  const showDeleteConfirm = (record) => {
    Modal.confirm({
      title: "Confirm Deletion",
      icon: <ExclamationCircleFilled />,
      content: <span>Do you want to delete this data record?</span>,
      okText: "Sure",
      cancelText: "Cancel",
      async onOk() {
        setLoading(true);
        try {
          const params = {
            id: record.id,
          };
          console.log(params);
          const response = await http.get(api.getApLicenseTypeDelete, {
            params,
          });
          if (response && response.code == 1) {
            message.success("Successfully delete.");
            getTableListFn(pagination.current, pagination.pageSize);
            setLoading(false);
          } else {
            message.error(response.msg);
          }
        } catch (error) {
          message.error("An error occurred. Please try again.");
        } finally {
          setLoading(false);
        }
      },
      onCancel() {
        console.log("Cancel");
      },
      style: {
        top: "40%",
      },
    });
  };
  // 修改active 状态
  const updateActiveStatus = async (id, activeValue) => {
    const res = await http.get(api.getApLicenseTypeUpdateStatus, {
      params: { id, status: activeValue },
    });
    return res;
  };
  // 每次 pagination 改变时同步 Ref// 更新 ref 当 tableHead 变化时
  useEffect(() => {
    paginationRef.current = pagination;
    tableHeadRef.current = tableHead;
  }, [pagination, tableHead]);

  const { confirm } = Modal;
  useEffect(() => {
    getTableListFn(pagination.current, pagination.pageSize);
  }, []);
  //列表
  const getTableListFn = async (page, pageSize, params = tableHead) => {
    setTableLoading(true);
    try {
      console.log("=====请求table======");
      const queryParams = {
        page,
        count: pageSize,
        businessType: params?.businessType || "",
        remark: params?.remark || "",
        status: params?.status || "",
        createByName: params?.createByName || "",
        updateByName: params?.updateByName || "",
      };
      const response = await http.get(api.getApLicenseTypeShow, {
        params: queryParams,
      });
      const dataWithKey = (response.data.list || [])?.map((item) => ({
        ...item,
        key: item.id,
      }));
      setFilteredData(dataWithKey);
      setPagination((prev) => ({
        ...prev,
        current: page,
        total: response.data.total || 0,
        pageSize: pageSize,
      }));
    } catch (err) {
      console.error("请求失败:", err);
      setError(err);
    } finally {
      setTableLoading(false);
    }
  };
  // 子组件回调
  const handleRoleUpdateSuccess = () => {
    getTableListFn(pagination.current, pagination.pageSize);
  };
  // 处理分页变化
  const handleTableChange = (newPagination, filters, sorter, extra) => {
    if (extra.action === "paginate") {
      // 分页变化时更新当前页码
      getTableListFn(newPagination.current, newPagination.pageSize, tableHead);
    } else if (extra.action === "sort") {
      // 排序变化时回到第一页
      getTableListFn(1, newPagination.pageSize, tableHead);
    }
  };

  return (
    <div>
      <Table
        rowClassName="table-row-gradient"
        loading={tableLoading}
        columns={columns.filter((col) => col.hidden === false)}
        dataSource={[...filteredData]}
        pagination={{
          showQuickJumper: true,
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: true,
          showTotal: (total) => {
            return `Total: ${total} items`;
          },
        }}
        rowKey="id" // 唯一标识
        onChange={handleTableChange} // 分页、排序、筛选变化时触发
        scroll={{
          x: "max-content", //横向滚动宽度
          y: "calc(100vh - 350px)", //纵向滚动高度
        }}
        className="my-Table"
      />

      <AddModal ref={addModalRef} onSuccess={handleRoleUpdateSuccess} />
      <UpdateModal ref={updateModalRef} onSuccess={handleRoleUpdateSuccess} />
    </div>
  );
});
export default MainTable;
